import { ITableAction } from '@mg-platform/core/core-feature'

export class GetAllNotifications {
  static readonly type = '[Notifications] Get All Notifications'
  constructor(public info: ITableAction) {}
}
